import { ERROR_MESSAGES } from "./errorMessages";

export class ApiError extends Error {
  status;

  constructor(status = 500, message) {
    super(message || ERROR_MESSAGES[status] || "Something went wrong");

    this.name = "ApiError";
    this.status = status;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ApiError);
    }
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}
